/**
 * Application configuration
 */
import { ThemeEnum } from '../enums/appEnum';
import { prefixCls } from '../settings/designSetting';
import projectSetting from '/@/settings/projectSetting';

import { useAppStore } from '/@/store/modules/app';
import { useLocaleStore } from '/@/store/modules/locale';

import { getCommonStoragePrefix, getStorageShortName } from '/@/utils/env';

// Initial project configuration
export function initAppConfigStore() {
  const localeStore = useLocaleStore();
  const appStore = useAppStore();
  const projCfg = projectSetting;
  appStore.setProjectConfig(projCfg);
  // appStore.setDarkMode(window.localStorage.getItem('__APP__DARK__MODE__') as any);
  appStore.setDarkMode(ThemeEnum.LIGHT);
  appStore.setPrefixCls(prefixCls);
  localeStore.initLocale();

  setTimeout(() => {
    clearObsoleteStorage();
  }, 16);
}

/**
 * As the version continues to iterate, there will be more and more cache keys stored in localStorage.
 * This method is used to delete useless keys
 */
export function clearObsoleteStorage() {
  const commonPrefix = getCommonStoragePrefix();
  const shortPrefix = getStorageShortName();

  [localStorage, sessionStorage].forEach((item: Storage) => {
    Object.keys(item).forEach((key) => {
      if (key && key.startsWith(commonPrefix) && !key.startsWith(shortPrefix)) {
        item.removeItem(key);
      }
    });
  });
}
